// noinspection JSUnusedGlobalSymbols
export enum ParseErrorTypes {
  Spacing = 'spacing',
  Expression = 'expression',
  Value = 'value',
  Input = 'input',
  Duplicates = 'duplicates',
}
